import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getBusinessPartnerStatus } from '../../../api/v2/businessPartner';
import { getNeeNorDetails } from '../../apiCalls';

export const businessPartnerQueryKeys = {
  status: (id, parentId) => ['v2', 'businessPartnerStatus', String(id), ...(parentId || [])],
};

export const useBusinessPartner = () => {
  const queryClient = useQueryClient();

  const fetchBusinessPartnerStatus = (id) => {
    if (!id) return Promise.resolve(null);

    return queryClient.fetchQuery({
      queryKey: businessPartnerQueryKeys.status(id),
      queryFn: () => getBusinessPartnerStatus(id),
      staleTime: 5 * 60 * 1000,
    });
  };

  return { fetchBusinessPartnerStatus };
};

export const useBusinessPartnerStatus = (id, parentId) =>
  useQuery({
    queryKey: businessPartnerQueryKeys.status(id, parentId),
    queryFn: () => getBusinessPartnerStatus(id, parentId),
    enabled: !!id,
    placeholderData: {
      id: null,
      companyName: '',
      cabieStatus: '',
      cabieStatusValid: false,
      dbStatus: '',
      dbStatusValid: false,
      billableCustomerValid: '',
      billableCustomer: false,
      cm8Approved: '',
      cm8ApprovedValid: false,
      isJiraTicketRequired: false,
    },
  });

export const useBusinessPartnerDetails = (id) =>
  useQuery({
    queryKey: ['v1', 'businessPartnerStatus', id],
    queryFn: async () => {
      const details = await getNeeNorDetails(id);
      return details?.[0];
    },
    staleTime: 10000,
    enabled: !!id,
    placeholderData: {},
  });
